import React from 'react';
import { default as IS_CLIENT } from "@pb/utils/constants/isClient";
import { default as useBreakpoint } from "@pb/utils/reactHooks/useBreakpoint";
import cn from 'classnames';
import styles from './ListGrid.module.scss';
const defaultNumberOfColumns = {
    xsmall: 2,
    small: 2,
    medium: 2,
    large: 3,
    xlarge: 4,
    xxl: 4,
};
const ListGrid = ({ children, className, gridGap, shouldHaveItemFlex = true, numberOfColumns = defaultNumberOfColumns, shouldNotHaveGridStyle, refElement, }) => {
    if (!children)
        return null;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const breakpointState = useBreakpoint();
    const currentNumberOfColumns = numberOfColumns[breakpointState];
    const style = shouldNotHaveGridStyle
        ? {
            gridTemplateColumns: 'none',
        }
        : IS_CLIENT ? {
            gridTemplateColumns: `repeat(${currentNumberOfColumns}, minmax(1px ,1fr))`,
        }
            : {};
    return (React.createElement("ul", { className: cn(shouldNotHaveGridStyle ? styles.list : styles.listGrid, className, gridGap && styles[gridGap], shouldHaveItemFlex && styles.itemFlex), style: style, ref: refElement }, React.Children.map(children, (child) => (React.createElement("li", { className: styles.item }, child)))));
};
export default ListGrid;
//# sourceMappingURL=ListGrid.js.map